// frontend/src/samkalp-faculty/mentoring/FacultyMentoringCallPage.js
import React from 'react';
import MentoringCallPage from '../../components/Common/MentoringCallPage';

const FacultyMentoringCallPage = () => (
    <MentoringCallPage role="faculty" backTo="/samkalp-ias/faculty/mentoring" />
);

export default FacultyMentoringCallPage;
